import * as c from './AddressSearchFieldConstants';

const INIT_STATE = {};

export default function(state = INIT_STATE, action) {
  const { type, payload } = action;
  const { id } = payload || {};

  switch (type) {
    case c.GET_RESULTS:
      return {
        ...state,
        [id]: fieldReducer(state[id], action)
      };
    case c.SET_RESULTS:
      return {
        ...state,
        [id]: fieldReducer(state[id], action)
      };
    case c.SET_SELECTED_TERM:
      return {
        ...state,
        [id]: fieldReducer(state[id], action)
      };
    case c.SET_LOAD_STATUS:
      return {
        ...state,
        [id]: fieldReducer(state[id], action)
      };
    case c.SET_ERROR:
      return {
        ...state,
        [id]: fieldReducer(state[id], action)
      };
    case c.INSERT_NEW_KEY:
      const { parentForm, form, index } = action.payload;
      let newState = {};
      
      for (let i = index; i >= 0; i--) {
        const id = `${parentForm}.${form}[${i}]`;
        
        if (i === 0) {
          newState[id] = {};
          
          continue;
        }

        const previousIndex = i - 1;
        const previousId = `${parentForm}.${form}[${previousIndex}]`; 
        
        newState[id] = fieldReducer(state[previousId], action);
      }

      return newState;
    default:
      return state;
  }
}

const FIELD_INIT_STATE = {
  isFetchingResults: false,
  isFetchingAddress: false,
  selectedTerm: '',
  result: null,
  results: [],
  error: null
};

function fieldReducer(state = FIELD_INIT_STATE, action) {
  const { type, payload } = action;

  switch (type) {
    case c.GET_RESULTS:
      return {
        ...state,
        error: null,
        results: [],
        isFetchingResults: true,
        isFetchingAddress: false
      };
    case c.SET_RESULTS:
      return {
        ...state,
        results: payload.results,
        isFetchingResults: false
      };
    case c.SET_SELECTED_TERM:
      return {
        ...state,
        results: [],
        error: null,
        selectedTerm: payload.selectedTerm,
        isFetchingResults: false,
        isFetchingAddress: true
      };
    case c.SET_LOAD_STATUS:
      const { status } = action.payload;

      return {
        ...state,
        isFetchingResults: status,
        isFetchingAddress: status
      };
    case c.SET_ERROR:
      const { error } = payload;

      if (!error) {
        return { ...state, error };
      }

      return {
        ...state,
        error,
        results: [],
        isFetchingResults: false,
        isFetchingAddress: false
      };
    case c.INSERT_NEW_KEY:
      return {
        ...state
      };
    default:
      return state;
  }
}
